var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 450",
    style: {
      enableBackground: "new 0 0 450 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_11_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_159_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st0",
    d: "M232.1,188.5c-11.1-58.3,59.1-93.1,100.4-51c0,0,18.5-5.2,34.7-15.5c0,0-5.9,19.9-25.8,32.5 c0,0,22.2-3,31.8-8.9c0,0-9.6,19.9-27.3,27.3c9.6,133.7-134.4,214.9-251.1,148.5c0,0,57.6,3,82-25.1c0,0-35.5,3-53.2-39.9 c0,0,13.3,5.2,26.6-1.5c0,0-41.4-6.6-45.1-56.1c0,0,13.3,10.3,28.1,6.6c0,0-45.8-27.3-19.9-76.8 C113.2,128.7,162,190.7,232.1,188.5L232.1,188.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.19f0a06dc69b59ff4be38fca243eedd5.svg";
export { ForwardRef as ReactComponent };